import { configureStore } from "@reduxjs/toolkit";
import filterPayloadReducer from "./actions/filterPayloadSlice";
import defaultSurveyCategoryReducer from "./actions/defaultSurveyCategory";
import surveyCategoryListsReducer from "./actions/surveyCategoryLists";
import communityDetailsReducer from "./actions/communityDetails";
import roleInfoReducer from "./actions/roleInfo";

export default configureStore({
  reducer: {
    filterPayload: filterPayloadReducer,
    surveyCategoryLists: surveyCategoryListsReducer,
    defaultSurveyCategoryReducer: defaultSurveyCategoryReducer,
    communityData: communityDetailsReducer,
    roleInfoData: roleInfoReducer,
  },
});
